import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4816c8f7")

_pushScopeId("data-v-4816c8f7")
const _hoisted_1 = { class: "relative bg-white rounded-xl mb-4" }
const _hoisted_2 = { class: "pb-4 mb-4 p-4 border-b" }
const _hoisted_3 = { class: "px-4 pb-2 grid grid-cols-2 gap-x-6 gap-y-2" }
const _hoisted_4 = { class: "mt-1.5" }
const _hoisted_5 = { class: "px-4 pb-2 grid grid-cols-2 gap-x-6 gap-y-2" }
const _hoisted_6 = { class: "py-3 flex flex-row gap-x-3" }
const _hoisted_7 = { class: "gap-x-3 flex flex-row lp-checkbox p-field-checkbox" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  class: "font-bold",
  for: "checkbox-intracity"
}, "INTRACITY", -1)
const _hoisted_9 = { class: "gap-x-3 flex flex-row lp-checkbox p-field-checkbox" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  class: "font-bold",
  for: "checkbox-intercity"
}, "INTERCITY", -1)
const _hoisted_11 = { class: "py-3 flex flex-row gap-x-3" }
const _hoisted_12 = { class: "gap-x-3 flex flex-row lp-checkbox p-field-checkbox" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "font-bold",
  for: "checkbox-intracity"
}, "On SLA", -1)
const _hoisted_14 = { class: "gap-x-3 flex flex-row lp-checkbox p-field-checkbox" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  class: "font-bold",
  for: "checkbox-intercity"
}, "Over SLA", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { label: "Aturan konfigurasi" })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_DataWrapper, {
        label: "Target pesan",
        asterisk: ""
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_MultipleSelectSearch, {
              ref: "targetField",
              "modal-title": "Pilih target pesan siapa",
              "option-name": "target",
              options: _ctx.targetOptions,
              modelValue: _ctx.targetSelected,
              onChange: _ctx.onChangeTarget,
              keyName: "name",
              keyValue: "value",
              placeholder: "Pilih target pesan siapa",
              "able-to-delete-in-modal": ""
            }, null, 8, ["options", "modelValue", "onChange"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Maksimal pesan",
        asterisk: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.form.msgConfMaxMessage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.msgConfMaxMessage = $event)),
            format: _ctx.formatNumber,
            placeholder: "Masukan nilai pesan"
          }, null, 8, ["modelValue", "format"])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_DataWrapper, {
        label: "Rute",
        asterisk: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-intracity",
                name: "route-message",
                modelValue: _ctx.form.msgConfIntracity,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.msgConfIntracity = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_8
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-intercity",
                name: "route-message",
                modelValue: _ctx.form.msgConfIntercity,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.msgConfIntercity = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_10
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "SLA",
        asterisk: ""
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-intracity",
                name: "route-message",
                modelValue: _ctx.form.msgConfOnSla,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.msgConfOnSla = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_13
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-intercity",
                name: "route-message",
                modelValue: _ctx.form.msgConfOverSla,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.msgConfOverSla = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_15
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
})